import { useQuery } from "@tanstack/react-query";
import { CustomDashboardService } from "../../services/CustomDashboardService";

export function useWidgetCatalog(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ["widget-catalog"],
    queryFn: () => CustomDashboardService.getWidgetCatalog(),
    staleTime: Infinity, // static — catalog doesn't change at runtime
    refetchOnWindowFocus: false,
    enabled: options?.enabled,
  });
}
